<div class="banner">
  <span class="banner-text" i18n>There are no invested funds available to rebalance.</span>
  <button
    *ngIf="isMemberPortal$ | async"
    (click)="goToAccounts()"
    class="account-button no-style-button"
    type="button"
    i18n>
    Go to Accounts
  </button>
</div>
